import React from 'react';

import Icon from '../Icon/Icon';

const StaccatoBlueIcon = (props) => {
    return (
        <Icon width='48' height='48' {...props}>
            <g strokeWidth='2' fill='none' fillRule='evenodd' strokeLinecap='round'>
                <path
                    d='M33.313 32.202c2.25-3.25 2.25-5.95 0-8.101-2.25-2.15-1.919-4.829.99-8.034M14.687 32.202c-2.25-3.25-2.25-5.95 0-8.101 2.25-2.15 1.919-4.829-.99-8.034'
                    stroke='#00D1D2'
                    className='icon-accent-stroke icon-accent-fill'
                />
                <path
                    d='M10.687 32.202c-2.25-3.25-2.25-5.95 0-8.101 2.25-2.15 1.919-4.829-.99-8.034M37.313 32.202c2.25-3.25 2.25-5.95 0-8.101-2.25-2.15-1.919-4.829.99-8.034'
                    stroke='#272A33'
                />
                <g stroke='#272A33'>
                    <path d='M20.052 8v32M27.947 8v32' />
                </g>
            </g>
        </Icon>
    );
};

export default StaccatoBlueIcon;
